import React, { useState } from 'react';

import { Box, Grid2, Paper, Typography } from '@mui/material';

const Scene = ({ current_scene, scene_image_id, tabHeight, BASE_URL, game_id, token }) => {

    const [isImageLoading, setIsImageLoading] = useState(true);

    return (
        <Box sx={{
            height: `calc(100vh - ${tabHeight}) `, // Full height minus tab height
            paddingTop: '5px', // Adds top padding
            boxSizing: 'border-box',
        }}>
            {/* Image Container */}
            <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 2, position: 'relative' }}>
                {isImageLoading && (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            height: '200px', // Placeholder height
                            backgroundColor: '#f0f0f0', // Placeholder background
                            borderRadius: '8px',
                        }}
                    >
                        <img src="/loading.gif"
                            alt="loading.gif"
                            style={{ height: '100px', width: 'auto' }} />
                    </Box>
                )}
                <img
                    src={`${BASE_URL}/v1/image/${game_id}/${scene_image_id}?token=${token}&a=b`}
                    alt="Scene"
                    style={{
                        display: isImageLoading ? 'none' : 'block',
                        width: '100%',
                        borderRadius: '8px',
                    }}
                    onLoad={() => setIsImageLoading(false)}
                    onError={() => setIsImageLoading(false)} // Optional: handle errors
                />
            </Box>

            <Paper elevation={3} sx={{ padding: 0, marginBottom: 2, textAlign: 'center' }}>
                <Typography variant="h6">{current_scene.scene_location}</Typography>
            </Paper>

            {/* NPCs Section */}
            <Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
                <Typography variant="h6">NPCs</Typography>
                {current_scene.npcs && current_scene.npcs.length > 0 ? (
                    <Grid2 container spacing={2}>
                        {current_scene.npcs.map((npc, index) => (
                            <Grid2 item="true" xs={12} key={index}>
                                <Typography>
                                    {npc.name || npc.type}
                                </Typography>
                            </Grid2>
                        ))}
                    </Grid2>
                ) : (
                    <Typography>No NPCs</Typography>
                )}
            </Paper>

            {/* Extras Section */}
            <Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
                <Typography variant="h6">Extras</Typography>
                {current_scene.extras && current_scene.extras.length > 0 ? (
                    <Grid2 container spacing={2}>
                        {current_scene.extras.map((extra, index) => (
                            <Grid2 item="true" xs={12} key={index}>
                                <Typography>{extra}</Typography>
                            </Grid2>
                        ))}
                    </Grid2>
                ) : (
                    <Typography>No extras</Typography>
                )}
            </Paper>

            {/* Objects Section */}
            <Paper elevation={3} sx={{ padding: 2 }}>
                <Typography variant="h6">Objects</Typography>
                {current_scene.objects && current_scene.objects.length > 0 ? (
                    <Grid2 container spacing={2}>
                        {current_scene.objects.map((obj, index) => (
                            <Grid2 item="true" xs={12} key={index}>
                                <Typography>{obj}</Typography>
                            </Grid2>
                        ))}
                    </Grid2>
                ) : (
                    <Typography>No objects</Typography>
                )}
            </Paper>
            <Box sx={{ height: '10px' }} />
        </Box>
    );
};

export default Scene;
